"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPDFCV(props, imageText) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const baseUrl = window.location.origin;
    let content = [];
    let section1 = {};
    let section2 = {};
    let section3 = {};
    let section4 = {};
    let section1Title = {};
    let section2Title = {};
    let section3Title = {};
    let section4Title = {};
    // Title like koulutus
    if (((_a = props.data.section1Title) === null || _a === void 0 ? void 0 : _a.value) != null && props.data.section1Title.value !== '') {
        // star-sized columns fill the remaining space
        // if there's more than one star-column, available width is divided equally
        // auto-sized columns have their widths based on their content
        section1Title = {
            width: '*',
            text: props.data.section1Title.value,
            fontSize: 25,
            margin: [0, 30, 0, 0],
            style: 'sectiontitle'
        };
    }
    // Title like Työkokemus
    if (((_b = props.data.section2Title) === null || _b === void 0 ? void 0 : _b.value) != null && props.data.section2Title.value !== '') {
        section2Title = {
            width: '*',
            text: props.data.section2Title.value,
            fontSize: 25,
            margin: [0, 30, 0, 0],
            style: 'sectiontitle'
        };
    }
    // Title like third one
    if (((_c = props.data.section3Title) === null || _c === void 0 ? void 0 : _c.value) != null && props.data.section3Title.value !== '') {
        section3Title = {
            width: '*',
            text: props.data.section3Title.value,
            fontSize: 25,
            margin: [0, 30, 0, 0],
            style: 'sectiontitle'
        };
    }
    // Title like four one
    if (((_d = props.data.section4Title) === null || _d === void 0 ? void 0 : _d.value) != null && props.data.section4Title.value !== '') {
        section4Title = {
            width: '*',
            text: props.data.section4Title.value,
            fontSize: 18,
            margin: [0, 30, 20, 0],
            style: 'sectiontitle'
        };
    }
    //function to create eduitems
    const createItems = (item) => {
        const list = [];
        if (item.items.length > 0) {
            item.items.forEach(function (s) {
                list.push(s);
            });
            return {
                style: 'edulist',
                ul: list
            };
        }
        else if (item.textItem && item.textItem !== '') {
            return {
                style: 'edulist',
                text: item.textItem
            };
        }
    };
    // Makes section1 content (koulutus)
    let section1Content = [];
    (_f = (_e = props.data.section1ChildItems) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.forEach(function (x) {
        section1Content.push({ text: x.title, style: 'eduhead' });
        section1Content.push(createItems(x));
    });
    section1 = {
        columns: [
            section1Title,
            {
                width: '45%',
                margin: [0, 30, 0, 20],
                stack: section1Content,
                style: 'edulist'
            }
        ]
    };
    if (section1.columns[1].stack.length === 0)
        section1 = '';
    // Makes section2 content (koulutus)
    let section2Content = [];
    (_h = (_g = props.data.section2ChildItems) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.forEach(function (x) {
        section2Content.push({ text: x.title, style: 'eduhead' });
        section2Content.push(createItems(x));
    });
    section2 = {
        columns: [
            section2Title,
            {
                width: '45%',
                margin: [0, 30, 0, 0],
                stack: section2Content,
                style: 'edulist'
            }
        ]
    };
    if (section2.columns[1].stack.length === 0)
        section2 = '';
    // Makes section3 content
    let section3Content = [];
    (_k = (_j = props.data.section3ChildItems) === null || _j === void 0 ? void 0 : _j.value) === null || _k === void 0 ? void 0 : _k.forEach(function (x) {
        section3Content.push({ text: x.title, style: 'eduhead' });
        section3Content.push(createItems(x));
    });
    section3 = {
        columns: [
            section3Title,
            {
                width: '45%',
                margin: [0, 30, 0, 0],
                stack: section3Content,
                style: 'edulist'
            }
        ]
    };
    if (section3.columns[1].stack.length === 0)
        section3 = '';
    // Makes section4 content
    let section4Content = [];
    (_m = (_l = props.data.section4ChildItems) === null || _l === void 0 ? void 0 : _l.value) === null || _m === void 0 ? void 0 : _m.forEach(function (x) {
        section4Content.push({ text: x.title, style: 'eduhead' });
        section4Content.push(createItems(x));
    });
    section4 = {
        columns: [
            section4Title,
            {
                width: '45%',
                margin: [0, 30, 0, 0],
                stack: section4Content,
                style: 'edulist'
            }
        ]
    };
    if (section4.columns[1].stack.length === 0)
        section4 = '';
    // fills content part
    content.push({
        columns: [
            {
                // auto-sized columns have their widths based on their content
                width: '*',
                stack: [
                    {
                        text: `${props.data.cvDate.value}\n`,
                        fontSize: 8,
                        margin: [0, 0, 0, 25],
                        color: '#4C4C4C'
                    },
                    {
                        text: `${props.data.personName.value}\n`,
                        fontSize: 30,
                        font: 'Roobert',
                        margin: [0, 0, 0, 25]
                    },
                    {
                        text: `${props.data.personTitle.value}\n`,
                        fontSize: 10,
                        lineHeight: 1.33,
                        margin: [0, 0, 0, 10]
                    },
                    {
                        text: `${props.data.additionalText.value}\n`,
                        fontSize: 8,
                        lineHeight: 1.5,
                        color: '#4C4C4C',
                        margin: [0, 0, 80, 0]
                    },
                ]
            },
            {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '45%',
                stack: [
                    { image: 'cv', width: '230', margin: [0, 0, 0, 5], alignment: 'left' },
                    { text: imageText, fontSize: 6 },
                ]
            }
        ],
        // optional space between columns
        columnGap: 10
    });
    if (section1 !== '')
        content.push(section1);
    if (section1 !== '' && section2 !== '')
        content.push({
            canvas: [
                {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 520,
                    y2: 5,
                    lineWidth: 0.5,
                    color: '#E4E4E4'
                }
            ]
        });
    if (section2 !== '')
        content.push(section2);
    if (section2 !== '' && section3 !== '')
        content.push({
            canvas: [
                {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 520,
                    y2: 5,
                    lineWidth: 0.5,
                    color: '#E4E4E4'
                }
            ]
        });
    if (section3 !== '')
        content.push(section3);
    if (section3 !== '' && section4 !== '')
        content.push({
            canvas: [
                {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 520,
                    y2: 5,
                    lineWidth: 0.5,
                    color: '#E4E4E4'
                }
            ]
        });
    if (section4 !== '')
        content.push(section4);
    const dd = {
        pageSize: 'A4',
        pageMargins: [40, 90, 40, 30],
        footer: function (currentPage, pageCount) {
            return {
                text: currentPage.toString() + '/' + pageCount,
                alignment: 'center',
                color: '#4C4C4C',
                margin: [0, 0, 0, 0],
                fontSize: 8,
            };
        },
        header: {
            // if you specify both width and height - image will be stretched
            image: 'logo',
            width: 107,
            alignment: 'center',
            margin: [0, 26, 0, 0]
        },
        content,
        images: {
            // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
            logo: `${baseUrl}/spaview/app.html.spa/sampocomlogo.png`,
            cv: (_p = (_o = props.data.mainImage) === null || _o === void 0 ? void 0 : _o.value) === null || _p === void 0 ? void 0 : _p.url
        },
        styles: {
            eduhead: {
                fontSize: 10,
                bold: true,
                color: '#4C4C4C',
                margin: [0, 10, 0, 5]
            },
            edulist: {
                fontSize: 10,
                color: '#4C4C4C',
                lineHeight: 1.5,
            }
        },
        defaultStyle: {
            font: 'Calibre'
        },
        pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
            // add break before section title if 1st eduhead is at different page or 1st edulist is at different page than 1st eduhead.
            if (currentNode.columns && currentNode.columns[0].style === 'sectiontitle') {
                if (currentNode.columns.length > 1 && currentNode.columns[1].stack && currentNode.columns[1].stack[0].nodeInfo.style === 'eduhead') {
                    if (currentNode.columns[0].nodeInfo.startPosition.pageNumber !== currentNode.columns[1].stack[0].nodeInfo.startPosition.pageNumber)
                        return true;
                    else if (currentNode.columns[1].stack.length > 1 && currentNode.columns[1].stack[1].nodeInfo.style === 'edulist' && currentNode.columns[1].stack[1].nodeInfo.pageNumbers.length > 1) {
                        return true;
                    }
                    else if (currentNode.columns[1].stack.length > 1 && currentNode.columns[1].stack[1].nodeInfo.style === 'edulist' && currentNode.columns[1].stack[0].nodeInfo.startPosition.pageNumber !== currentNode.columns[1].stack[1].nodeInfo.startPosition.pageNumber) {
                        return true;
                    }
                }
            }
            // if edulist followed by eduhead is at two pages, add break before eduhead.
            if (currentNode.style === 'eduhead' && followingNodesOnPage[0].style === 'edulist' && (followingNodesOnPage[0].ul && followingNodesOnPage[0].ul.length > 0)) {
                if (currentNode.startPosition.pageNumber !== followingNodesOnPage[0].pageNumbers.pop())
                    return true;
            }
            // if eduhead is last element of the page, add break before
            if (currentNode.style === 'eduhead' && followingNodesOnPage.length < 3) {
                return nodesOnNextPage[0].style === 'edulist' && (nodesOnNextPage[0].ul && nodesOnNextPage[0].ul.length > 0);
            }
            return false;
        },
    };
    const pdfMake = require('pdfmake/build/pdfmake.js');
    pdfMake.fonts = {
        Calibre: {
            normal: `${baseUrl}/spaview/app.html.spa/fonts/Calibre2-Regular.otf`,
            bold: `${baseUrl}/spaview/app.html.spa/fonts/Calibre2-Medium.otf`,
            italics: `${baseUrl}/spaview/app.html.spa/fonts/Calibre2-Regular.otf`,
            bolditalics: `${baseUrl}/spaview/app.html.spa/fonts/Calibre2-Regular.otf`
        },
        Roobert: {
            normal: `${baseUrl}/spaview/app.html.spa//fonts/Roobert-Medium.otf`,
            bold: `${baseUrl}/spaview/app.html.spa/fonts/Roobert-Medium.otf`,
            italics: `${baseUrl}/spaview/app.html.spa//fonts/Roobert-Medium.otf`,
            bolditalics: `${baseUrl}/spaview/app.html.spa//fonts/Roobert-Medium.otf`
        }
    };
    pdfMake.createPdf(dd).download(`${props.data.personName.value}` + ' CV');
    /* Debugging section to show pdf in iframe
    const pdfDocGenerator = pdfMake.createPdf(dd)
    pdfDocGenerator.getDataUrl((dataUrl: string) => {
        const targetElement = document.querySelector('#iframeContainer')
        const iframe = document.createElement('iframe')
        iframe.src = dataUrl
        targetElement.appendChild(iframe)
    })*/
}
exports.default = getPDFCV;
